export default "/images/tryg.avif?ee6279fb54d574207d9be73180b324ad";